import { IconActivity } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";

import { PageHeader } from "@/components/page-header";
import { useDocumentTitle } from "@/lib/use-document-title";

/** Ported verbatim from portal-ui/app/(support)/bg/page.tsx. */
export const Route = createFileRoute("/_app/_support/bg")({
  component: BgPage,
});

function BgPage() {
  useDocumentTitle("Background jobs");
  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-6">
      <PageHeader eyebrow="Admin" title="Background jobs" meta="No active jobs." />

      <section className="flex flex-col items-center gap-3 rounded-2xl border border-border/60 bg-card p-10 text-center shadow-[var(--shadow-bento)]">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-emerald-500/10 text-emerald-600 ring-1 ring-inset ring-emerald-500/30 dark:text-emerald-400">
          <IconActivity size={22} />
        </div>
        <div className="space-y-1">
          <p className="text-sm font-semibold tracking-tight">All clear</p>
          <p className="text-xs text-muted-foreground">
            No background work is currently queued or running.
          </p>
        </div>
      </section>
    </div>
  );
}
